var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.75H10.5C10.6326 7.75 10.7598 7.80268 10.8536 7.89645C10.9473 7.99021 11 8.11739 11 8.25C11 8.38261 10.9473 8.50979 10.8536 8.60355C10.7598 8.69732 10.6326 8.75 10.5 8.75H5.5C5.36739 8.75 5.24021 8.69732 5.14645 8.60355C5.05268 8.50979 5 8.38261 5 8.25C5 8.11739 5.05268 7.99021 5.14645 7.89645C5.24021 7.80268 5.36739 7.75 5.5 7.75Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.25C8.78793 14.25 9.56815 14.0948 10.2961 13.7933C11.0241 13.4917 11.6855 13.0498 12.2426 12.4926C12.7998 11.9355 13.2417 11.2741 13.5433 10.5461C13.8448 9.81815 14 9.03793 14 8.25C14 7.46207 13.8448 6.68185 13.5433 5.9539C13.2417 5.22595 12.7998 4.56451 12.2426 4.00736C11.6855 3.45021 11.0241 3.00825 10.2961 2.70672C9.56815 2.40519 8.78793 2.25 8 2.25C6.4087 2.25 4.88258 2.88214 3.75736 4.00736C2.63214 5.13258 2 6.6587 2 8.25C2 9.8413 2.63214 11.3674 3.75736 12.4926C4.88258 13.6179 6.4087 14.25 8 14.25ZM8 15.25C6.14348 15.25 4.36301 14.5125 3.05025 13.1997C1.7375 11.887 1 10.1065 1 8.25C1 6.39348 1.7375 4.61301 3.05025 3.30025C4.36301 1.9875 6.14348 1.25 8 1.25C9.85652 1.25 11.637 1.9875 12.9497 3.30025C14.2625 4.61301 15 6.39348 15 8.25C15 10.1065 14.2625 11.887 12.9497 13.1997C11.637 14.5125 9.85652 15.25 8 15.25Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.2adac82bffb102c1552bdf5fa17ac1b9.svg";
export { ForwardRef as ReactComponent };